/**
 * NOTE: All enums within this file share the same value pool,
 * meaning that all enums should have unique values, even between
 * sets (i.e. cannot have value 1 in both NoGroupHeaderId AND
 * TimeHeaderId).
 */
export type GroupHeaderId =
    | NoGroupHeaderId
    | SizeHeaderId
    | TimeHeaderId
    | SenderGroupHeaderId
    | PinnedGroupHeaderId
    | CategoryGroupHeaderId
    | SubjectGroupHeaderId
    | FlagDueDateHeaderId
    | string;

export enum NoGroupHeaderId {
    None = 0,
}

export enum TimeHeaderId {
    Pinned = 1,
    Today = 2,
    Yesterday = 3,
    ThisWeek = 4,
    LastWeek = 5,
    ThisMonth = 6,
    LastMonth = 7,
    Older = 8,
    OneMonthOlder = 9,
    TwoMonthsOlder = 10,
}

export enum SizeHeaderId {
    Tiny = 11, // > 0kb
    Small = 12, // > 10kb
    Medium = 13, // > 25kb
    Large = 14, // > 1mb
    VeryLarge = 15, // > 5mb
    Huge = 16, // > 10MB
    Enormous = 17,
}

export enum SenderGroupHeaderId {
    Unknown = 18,
}

export enum PinnedGroupHeaderId {
    Pinned = 20,
}

export enum CategoryGroupHeaderId {
    Category = 21,
}

export enum SubjectGroupHeaderId {
    Subject = 22,
}

export enum FlagDueDateHeaderId {
    NoDate = 23,
    NextWeek = 24,
    Tomorrow = 25,
    Today = 26,
    Later = 27,
}
